import { useNavigate } from "react-router-dom";

const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Pricing", href: "/pricing" },
  { label: "Co-Creator Offer", href: "/co-creator", highlight: true },
  { label: "FAQ", href: "/faq" },
  { label: "Get Started", href: "#register" },
];

const CO_CREATOR_LINKS = [
  { label: "Join the Programme", href: "#register" },
  { label: "Founding Offer", href: "/co-creator" },
  { label: "How It Works", href: "#how-it-works" },
];

const LEGAL_LINKS = [
  { label: "Privacy Policy", href: "#" },
  { label: "Terms of Use", href: "#" },
  { label: "Cookie Policy", href: "#" },
];

const OFFICES = [
  { city: "London", number: "+44 2033 182881" },
  { city: "New York", number: "+1 212 899 5288" },
  { city: "Hong Kong", number: "+852 5808 4880" },
];

export default function Footer() {
  const navigate = useNavigate();

  const handleNav = (href: string) => {
    if (href === "#") return;
    if (!href.startsWith("#")) {
      navigate(href);
      return;
    }
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#EFEBE5] border-t border-[#D8D2C6]">
      {/* Main footer grid */}
      <div className="max-w-6xl mx-auto px-6 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
        {/* Brand column */}
        <div className="lg:col-span-2 flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <img
              src="/assets/images/logo.svg"
              alt="Envizage"
              className="h-8 w-auto"
            />
          </div>
          <p className="text-xs text-[#7a7a8a] leading-relaxed max-w-[220px]">
            Conversational financial planning AI, built for UK planners.
          </p>
          <div className="flex flex-col gap-2 mt-1">
            <div className="flex items-start gap-2">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-map-pin-line text-xs text-brown-300"></i>
              </div>
              <p className="text-xs text-[#5a5a6a] leading-relaxed">
                142 Cromwell Road
                <br />
                London, SW7 4EF
              </p>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-xs text-brown-300"></i>
              </div>
              <a
                href="mailto:contact-us@envizage.me"
                className="text-xs text-[#5a5a6a] hover:text-amber-700 transition-colors"
              >
                contact-us@envizage.me
              </a>
            </div>
          </div>
          <p className="text-xs text-[#9a9aaa] mt-auto">
            FCA-regulated market. UK-based team.
          </p>
        </div>

        {/* Navigation column */}
        <div className="flex flex-col gap-3">
          <h4 className="text-xs font-semibold uppercase tracking-widest text-[#9a9aaa]">
            Navigation
          </h4>
          <ul className="flex flex-col gap-2">
            {NAV_LINKS.map(({ label, href, highlight }) => (
              <li key={label}>
                <a
                  href={href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNav(href);
                  }}
                  rel="nofollow"
                  className={`text-md transition-colors cursor-pointer whitespace-nowrap ${
                    highlight
                      ? "inline-flex items-center gap-1 font-semibold text-amber-600 hover:text-amber-700"
                      : "text-[#4a4a5a] hover:text-amber-700"
                  }`}
                >
                  {highlight && <i className="ri-vip-crown-line text-xs" />}
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Co-Creator column */}
        <div className="flex flex-col gap-3">
          <h4 className="text-xs font-semibold uppercase tracking-widest text-[#9a9aaa]">
            Co-Creator
          </h4>
          <ul className="flex flex-col gap-2">
            {CO_CREATOR_LINKS.map(({ label, href }) => (
              <li key={label}>
                <a
                  href={href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNav(href);
                  }}
                  rel="nofollow"
                  className="text-md text-[#4a4a5a] hover:text-amber-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
          {/* <a
            href="#register"
            onClick={(e) => {
              e.preventDefault();
              handleNav("#register");
            }}
            className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold bg-amber-500 text-white px-3 py-1.5 rounded hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap w-fit"
          >
            <i className="ri-sparkling-line text-xs w-3 h-3 flex items-center justify-center" />
            Register Interest
          </a> */}
        </div>

        {/* Contact column */}
        <div className="flex flex-col gap-3">
          <h4 className="text-xs font-semibold uppercase tracking-widest text-[#9a9aaa]">
            Get in Touch
          </h4>
          <ul className="flex flex-col gap-3">
            {OFFICES.map(({ city, number }) => (
              <li key={city} className="flex flex-col gap-0.5">
                <span className="text-[10px] font-bold text-brown-300 uppercase tracking-wider">
                  {city}
                </span>
                <a
                  href={`tel:${number.replace(/\s/g, "")}`}
                  className="text-md text-[#4a4a5a] hover:text-amber-700 transition-colors whitespace-nowrap"
                >
                  {number}
                </a>
              </li>
            ))}
          </ul>
          {/* <div className="mt-2 flex flex-col gap-1 pt-3 border-t border-[#D8D2C6]">
            {LEGAL_LINKS.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                rel="nofollow"
                className="text-xs text-[#4a4a5a] hover:text-amber-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                {label}
              </a>
            ))}
          </div> */}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#D8D2C6]">
        <div className="max-w-6xl mx-auto px-6 py-5 flex flex-col items-start justify-between gap-3">
          <p className="text-xs text-[#9a9aaa]">
            &copy; 2026{" "}
            <strong className="text-[#7a7a8a] font-semibold">
              Lifescale Limited
            </strong>{" "}
            trading as Envizage. All rights reserved.
          </p>
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            {/* <div className="flex flex-col gap-2"> */}

            <p className="text-xs text-[#7a7a8a]">
              Envizage is registered with the U.K. Financial Conduct Authority
              under the Payment Services Regulations 2017 for the provision of
              payment services. Our FCA register reference number is 825503 and
              you can find our details{" "}
              <a
              className="underline"
                href="https://register.fca.org.uk/ShPo_FirmDetailsPage?id=0010X00004IMbfTQAT"
                target="_blank"
              >
                here
              </a>
              .
            </p>
            {/* </div> */}
            <p className="text-xs text-[#7a7a8a] flex flex-wrap gap-x-3 gap-y-1">
              <span>
                Companies House:{" "}
                <strong className="font-semibold">07476290</strong>
              </span>
              <span className="hidden sm:inline text-[#D8D2C6]">·</span>
              <span>
                VAT: <strong className="font-semibold">121385049</strong>
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
